import React from "react";
import { motion } from "motion/react";
import { cn, scrollToElement } from "@/lib/utils";
import Link from "next/link";

type NavLinkProps = {
  text: string;
  href?: string;
  scrollTo?: string;
  containerClassName?: string;
  textClassName?: string;
  onClick?: () => void;
  target?: string;
  rel?: string;
};

const NavLink = ({
  text,
  href,
  scrollTo,
  containerClassName = "",
  textClassName = "",
  onClick,
  target,
  rel,
}: NavLinkProps) => {
  const textVariants = {
    initial: {
      y: 0,
    },
    hovered: {
      y: "-100%",
    },
  };

  const animatedTextVariants = {
    initial: {
      y: "100%",
    },
    hovered: {
      y: 0,
    },
  };

  const handleClick = () => {
    if (scrollTo) {
      scrollToElement(scrollTo);
    }
    if (onClick) {
      onClick();
    }
  };

  const MotionContent = () => (
    <motion.div
      className={cn(
        "relative overflow-hidden cursor-pointer",
        containerClassName
      )}
      initial="initial"
      whileHover="hovered"
      onClick={handleClick}
    >
      {/* original text */}
      <motion.p
        className={cn(
          "text-2xl font-editorial tracking-[-0.03em]",
          textClassName
        )}
        variants={textVariants}
        transition={{
          duration: 0.5,
          ease: [0.87, 0, 0.13, 1],
        }}
      >
        {text}
      </motion.p>
      {/* animatable text */}
      <motion.p
        className={cn(
          "text-2xl font-editorial tracking-[-0.03em] absolute inset-0",
          textClassName
        )}
        variants={animatedTextVariants}
        transition={{
          duration: 0.5,
          ease: [0.87, 0, 0.13, 1],
        }}
      >
        {text}
      </motion.p>
    </motion.div>
  );

  return href ? (
    <Link href={href} target={target} rel={rel}>
      <MotionContent />
    </Link>
  ) : (
    <MotionContent />
  );
};

export default NavLink;
